'use client';

import { useEffect } from 'react';

//Workaround for bug: https://github.com/vercel/next.js/issues/42492
export const ScrollUp = () => {
  useEffect(() => {
    window.document.scrollingElement?.scrollTo(0, 0);
  }, []);

  return null;
};
